import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Home.css";
const Testimonial = () => {
  return (
    <div className="review pt_100 xs_pt_70 pb_100 xs_pb_70">
      <Container>
        <Row>
          <Col md={12}>
            <div className="section-title common_heading center_heading mb_45">
              <div className="title-header">
                <h3 style={{ width: "max-content", margin: "auto" }}>
                  Testimonial
                </h3>
              </div>
              <h2>What Our Client Says</h2>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <div className="single_review">
              <p className="review_icon">
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
              </p>
              <p>
                “ I’m very satisfied with my surgery results. The surgeon was
                kind and humble, clearly explaining my options. I’m grateful for
                her expertise, and the staff was always polite and cooperative.”
              </p>
              <div className="reviewer_info">
                <div className="img">
                  <img
                    src="/Images/testi-one.jpeg"
                    alt="reviewer"
                    className="img-fluid w-100"
                  />
                </div>
                <h3>Ashish Malhorta</h3>
                <span>Patient</span>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="single_review">
              <p className="review_icon">
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
              </p>
              <p>
                “Initially, I felt a bit apprehensive, but after meeting the
                staff and the doctor, I felt more at ease and optimistic about
                the rhinoplasty. After the surgery, I was extremely satisfied
                and happy with my new nose.”
              </p>
              <div className="reviewer_info">
                <div className="img">
                  <img
                     src="/Images/testi-three.jpeg"
                    alt="reviewer"
                    className="img-fluid w-100"
                  />
                </div>
                <h3>Vivan Sharma</h3>
                <span>Patient</span>
              </div>
            </div>
          </Col>
          <Col md={4}>
            <div className="single_review">
              <p className="review_icon">
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
                <i className="fas fa-star" aria-hidden="true" />
              </p>
              <p>
                “The doctor is excellent and a compassionate person. They are
                approachable and attentive to patients’ needs, with a warm staff
                that supports their expert guidance in enhancing confidence.”
              </p>
              <div className="reviewer_info">
                <div className="img">
                  <img
                     src="/Images/testi-two.jpeg"
                    alt="reviewer"
                    className="img-fluid w-100"
                  />
                </div>
                <h3>Shruti Kumari</h3>
                <span>Patient</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Testimonial;
